import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { MyHrDataCollapse } from "my-hr/components";
import { MyHrAddPermissionForm } from "my-hr/forms";
import { OcCard } from "oc/components";
import { getFullname } from "oc/utils";

type MyHrAddPermissionProps = {
  employee: any; // Replace 'any' with the actual employee type if available
  contractsData: any; // Replace 'any' with the actual contractsData type if available
  user: any; // Replace 'any' with the actual user type if available
  setUser: (user: any) => void; // Adjust the type as needed
  dateError: any; // Replace 'any' with the actual dateError type if available
  isMobile: boolean;
};

export const MyHrAddPermission = ({
  employee,
  contractsData,
  user,
  setUser,
  dateError,
  isMobile,
}: MyHrAddPermissionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (employee?.code !== user.employee) {
      setUser({ employee: employee?.code });
    }
  }, [employee?.code, user.employee, setUser]);

  useEffect(() => {
    const fullname = getFullname(employee);
    if (employee && fullname) {
      setUser({ fullname });
    }
  }, [employee, setUser]);
  return (
    <Box>
      <Box id="user-data-collapse">
        <MyHrDataCollapse
          id="testIdCollapse"
          employee={employee}
          contractsData={contractsData}
          isMobile={isMobile}
        />
      </Box>
      <OcCard label={t("MY_HR_ADD_PERMISSION")}>
        <Box id="add-permission-form">
          <MyHrAddPermissionForm
            user={user}
            setUser={setUser}
            dateError={dateError}
            employee={employee}
            isMobile={isMobile}
          />
        </Box>
      </OcCard>
    </Box>
  );
};

export default MyHrAddPermission;
